module.exports = __webpack_public_path__ + "img/logo.208f5d8b.png";